import { ImageResourceDTO } from '@/model/ImageResourceDTO';

import { chunk } from 'lodash-es';

function generateSizes(...args: string[]): string {
	return chunk(args, 2).filter(a => a.length == 2).map(a => `(min-width: ${a[0]}) calc((${a[1]}) - 2 * 15px)`).join() + ",calc(100vw - 2 * 15px)";
}

export function formatImageUrl(url: string) {
	if (url.match(/^([a-zA-Z]+:)?\/\//)) {
		return url;
	}

	return `//www.central-group.cz/Uloziste/${url}`;
}

/**
 * Returns image of the proper size (i.e. nearest greater or equal to the specified size)
 */
export function getProperSize(images: ImageResourceDTO[], width: number): ImageResourceDTO {
	return images.find(r => r.width >= width) || images[images.length - 1];
}

export function sizesInColumns(numColumns1200: number, numColumns992: number, numColumns768: number, numColumns576: number = null): string {
	var sizes = [
		"1200px", `1140px / 12 * ${numColumns1200}`,
		"992px", `960px / 12 * ${numColumns992}`,
		"768px", `720px / 12 * ${numColumns768}`
	].concat(numColumns576 ? ["576px", `540px / 12 * ${numColumns576}`] : []);

	return generateSizes(...sizes);
}
